export default __webpack_public_path__ + "static/media/template_pro__0011_16---EltonTsang.0f0c2651.png";